import styled from "@emotion/styled";

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const InnerWrapper = styled.div`
  display: block;
  text-align: center;
  padding: 0px 35px;
`;

export const Icon = styled.span`
  font-size: 28px;
  color: #b0b0b0;
  margin-bottom: 10px;
  display: block;
  color: #2f8de4;
`;

export const Title = styled.span`
  display: block;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  display: block;
  color: #3b3b3b;
  font-size: 14px;
`;

export const Text = styled.span`
  font-family: Poppins, sans-serif;
  display: block;
  color: grey;
  font-size: 12px;
  margin-top: 5px;
`;
